import { render } from "./SidebarDesktop.vue?vue&type=template&id=65fcb68c&scoped=true"
import script from "./SidebarDesktop.vue?vue&type=script&lang=js"
export * from "./SidebarDesktop.vue?vue&type=script&lang=js"

import "./SidebarDesktop.vue?vue&type=style&index=0&id=65fcb68c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fcb68c"]])

export default __exports__